// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.selectors .container[data-v-3d87ff94]{display:grid;grid-template-columns:1fr 1fr}@media (min-width:768px){.selectors .container[data-v-3d87ff94]{grid-template-columns:repeat(3,1fr)}}.selectors .container.icon[data-v-3d87ff94]{grid-template-columns:1fr;grid-gap:1.6rem;gap:1.6rem}.selectors .container.icon .label[data-v-3d87ff94]{font-weight:500}.selectors .last-item[data-v-3d87ff94]{margin-top:1.6rem;cursor:pointer}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
